
import { randomValues } from '@/mixins/random';

export default {
	state: {
		tiles: [],
		rows: 0,
		columns: 0,
		baseColor: null,
	},
	actions: {
		fillAllTiles(context, payload) {
			while (context.getters.vacantTiles.length) {
				context.dispatch("fillTile", {
					breed: context.rootGetters.randomBreedName(),
					state: payload.catState,
				});
			}
			context.dispatch("allTilesFilled");
		},
		// fillTiles(context, payload) {
		// 	function fillAll() {
		// 		context.dispatch("fillTile", payload.items.splice(0, 1)[0]);
		// 		if (payload.items.length) {
		// 			requestAnimationFrame(fillAll);
		// 		}
		// 	}

		// 	requestAnimationFrame(fillAll);
		// },
		fillTile(context, payload) {
			if (context.getters.vacantTiles.length) {
				context.getters.randomTiles(1).map(tile => tile.insertCat(payload.breed, payload.state));
			} else {
				context.commit("wipeGame");
			}
		},
	},
	mutations: {
		registerTile(state, payload) {
			state.tiles.push(payload.tile);
		},
		deregisterAllTiles(state) {
			state.tiles = [];
		},
		setBoardColor(state, payload) {
			state.baseColor = payload.color;
		},
	},
	getters: {
		vacantTiles(state) {
			return state.tiles.filter(tile => tile.vacant);
		},
		occupiedTiles(state) {
			return state.tiles.filter(tile => !tile.vacant && !tile.blocked);
		},
		blockedTiles(state) {
			return state.tiles.filter(tile => tile.blocked);
		},
		randomTiles(state, getters) {
			return count => randomValues(getters.vacantTiles, count);
		},
	},
};



// WEBPACK FOOTER //
// ./src/store/board.js